import { yupResolver } from '@hookform/resolvers/yup';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import {
  Button,
  Container,
  Feedback,
  Htag,
  HtagAlign,
  HtagVariant,
} from '../../components';
import Checkbox from '../../components/checkbox';
import TextField from '../../components/text-field';
import { useModal } from '../../hooks';
import { sendMessage } from '../../services/contact.service';
import styles from './logistic-contact.module.css';
import LogisticSlider from './logistic-slider';

export enum ContactFormField {
  email = 'email',
  name = 'name',
  message = 'message',
}

export interface ContactForm {
  [ContactFormField.email]: string;
  [ContactFormField.name]: string;
  [ContactFormField.message]: string;
}

const schema = yup.object().shape({
  [ContactFormField.email]: yup
    .string()
    .email()
    .trim()
    .required('email is required'),
  [ContactFormField.name]: yup.string().trim().required('name is required'),
  [ContactFormField.message]: yup.string().required('message is required'),
});

export default function LogisticContact() {
  const { open, setContent } = useModal();
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<ContactForm>({
    mode: 'onBlur',
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data: ContactForm) => {
    const response = await sendMessage(data);
    setIsSubmitted(true);

    if (String(response.status).startsWith('2')) {
      setContent(<Feedback />);
      open();
      reset();
    }
    setIsSubmitted(false);
  };

  return (
    <div className={styles.root}>
      <Container>
        <Htag
          variant={HtagVariant.h2}
          align={HtagAlign.center}
          className={styles.title}
          tag="h2"
        >
          Start growing your business with us
        </Htag>

        <div className={styles.wrapper}>
          <form className={styles.form}>
            <div className={styles.row}>
              <TextField
                label="Name"
                disabled={isSubmitted}
                className={styles.input}
                error={!!errors?.[ContactFormField.name]}
                message={errors?.[ContactFormField.name]?.message}
                {...register(ContactFormField.name)}
              />
              <TextField
                label="Email"
                disabled={isSubmitted}
                className={styles.input}
                error={!!errors?.[ContactFormField.email]}
                message={errors?.[ContactFormField.email]?.message}
                {...register(ContactFormField.email)}
              />
            </div>
            <div className={styles.row}>
              <TextField
                label="Message"
                disabled={isSubmitted}
                className={styles.input}
                error={!!errors?.[ContactFormField.message]}
                message={errors?.[ContactFormField.message]?.message}
                {...register(ContactFormField.message)}
              />
            </div>
            <div className={styles.row}>
              <Checkbox disabled={isSubmitted} label="Send NDA" />
            </div>
            <div className={styles.row} style={{ alignItems: 'center' }}>
              <p className={styles.text}>
                By sending this form I confirm that I have read and accept the
                <a href="#" className={styles.link}>
                  Privacy Policy
                </a>
              </p>
              <Button
                appearance="primary"
                type="submit"
                onClick={handleSubmit(onSubmit)}
              >
                send message
              </Button>
            </div>
          </form>
          <LogisticSlider />
        </div>
      </Container>
    </div>
  );
}
